export const env = {
  PROD: import.meta.env.PROD,
  DEV: import.meta.env.DEV,
  MODE: import.meta.env.MODE,
  CATALOG_API: import.meta.env.VITE_CATALOG_API as string | undefined,
  SOCKET_URL: import.meta.env.VITE_SOCKET_URL as string | undefined,
  BUCKET_URL: import.meta.env.VITE_BUCKET_URL as string | undefined,
  FEED_URL: import.meta.env.VITE_FEED_URL as string | undefined,
};
